import React from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';
import { BUTTON_SIZES, BUTTON_VARIANTS, Button } from 'ui/button';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { fontWeights } from 'ui/theme';

interface DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  name: string;
}

export const BoldSpan = styled.span`
  font-weight: ${fontWeights.bold};
`;

export const DeleteModal: React.FC<React.PropsWithChildren<DeleteModalProps>> = ({
  isOpen,
  onClose,
  onDelete,
  name,
}) => {
  const { handleSubmit } = useForm();

  const handleDelete = () => {
    onDelete();
    onClose();
  };

  return (
    <Modal
      id="metric-definition-delete-modal"
      isModalOpen={isOpen}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader id="metric-definition-delete-modal-header" onClose={onClose}>
        Delete metric definition?
      </ModalHeader>
      <form onSubmit={handleSubmit(handleDelete)}>
        <ModalBody id="metric-definition-delete-modal-body">
          <p>
            Are you sure you want to delete <BoldSpan>{name}</BoldSpan>? This action cannot be
            undone.
          </p>
        </ModalBody>
        <ModalFooter id="metric-definition-delete-modal-footer" onClose={onClose}>
          <Button type="submit" size={BUTTON_SIZES.LARGE} variant={BUTTON_VARIANTS.DESTRUCTIVE}>
            Delete metric definition
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};
